import { IMedia } from "@/interfaces/media.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

import { CHAT_MEDIA_MAX_HEIGHT_PX } from "../../media-size";
import ChatImagePreview from "../ChatImagePreview";

interface ImageProps {
  media: IMedia;
  mediaURL: string;
  messages: CurrentChatMessages;
}

const ImageMedia: React.FC<ImageProps> = ({ media, mediaURL, messages }) => {
  const hasExtension = Boolean(media.extension) && media.name.includes(`.${media.extension}`);
  const fileName = hasExtension || !media.extension ? media.name : `${media.name}.${media.extension}`;

  return (
    <ChatImagePreview
      src={mediaURL}
      alt={media.caption || media.name}
      fileName={fileName}
      messages={messages}
      thumbnailStyle={{
        display: "block",
        width: "auto",
        height: "auto",
        maxWidth: "100%",
        maxHeight: CHAT_MEDIA_MAX_HEIGHT_PX,
        objectFit: "contain",
        objectPosition: "center",
        borderRadius: 8,
      }}
    />
  );
};

export default ImageMedia;
